<template>
  <div
    v-if="thisstatedata"
    :key="thisparent + $store.state.counter"
    :class="'state_' + thisparent"
    class="state_component"
    :style="`margin-left: ${nesting * 4}px`"
  >
    <b
      v-if="editable && createable"
      class="xs-font update-text flex align-center"
    >
      <button
        class="update xs-font"
        type="button"
        @click="editmode = !editmode"
      >
        <i class="fa fa-plus r4"></i> Create
      </button>
      <span>{{ thisparent }}</span>
    </b>
    <div v-if="editmode">
      <row j="between">
        <b>{{ name }}</b>
        <div class="xs-font">
          Add data to
          {{ Array.isArray(thisstatedata) ? "array" : typeof thisstatedata }}:
        </div>
        <select
          @change="
            Array.isArray(thisstatedata)
              ? thisstatedata.push(createtype(add[thisparent]))
              : $set(
                  thisstatedata,
                  thisparent + ' new key',
                  createtype(add[thisparent])
                );
            $set(add, thisparent, !add[thisparent]);
          "
          v-model="add[thisparent]"
          v-if="typeof thisstatedata == 'object'"
        >
          <option class="update" disabled selected>
            <i class="fa fa-plus update-text" />
          </option>
          <option
            :key="datatype"
            :value="datatype"
            v-for="datatype in [
              'String',
              'Number',
              'Array',
              'Object',
              'Boolean',
            ]"
          >
            {{ datatype }}
          </option>
        </select>
      </row>
      <div
        :class="newkey[k] ? 'indicate-border' : ''"
        class="xs-font container p4"
        v-for="(v, k) in thisstatedata"
        :key="thisparent + '.' + k"
      >
        <div>
          <i
            class="update-text m4 fas fa-folder-plus"
            :class="
              is(v) == 'array' || (validjson(v) && is(JSON.parse(v)) == 'array')
                ? 'fa-folder-plus'
                : 'fa-cubes-plus'
            "
            @click="
              $set(
                show,
                'createitem' + thisparent + k,
                !show['createitem' + thisparent + k]
              )
            "
            v-if="createable"
          />
          <span class="flex wrap align-center xs-font">
            <input
              placeholder="New item type"
              type="text"
              class="xs-font xs-input"
              v-if="show['createitem' + thisparent + k]"
              v-model="newinput['createitem' + thisparent + k]"
            />
            <button
              v-if="newinput['createitem' + thisparent + k]"
              @click="
                createitem(newinput['createitem' + thisparent + k], v);
                $set(newinput, 'createitem' + thisparent + k, '');
                $set(show, 'createitem' + thisparent + k, false);
              "
              type="button"
              class="xs-font p4 success"
            >
              Create {{ Array.isArray(v) ? " and append" : "" }}
            </button>
            <div
              class="flex align-center"
              @click="
                v !== 'object' && v !== 'boolean'
                  ? $set(
                      show,
                      'deepstate.' + thisparent + '.' + k,
                      !show['deepstate.' + thisparent + '.' + k]
                    )
                  : null
              "
            >
              <i
                v-if="v !== 'object' && v !== 'boolean'"
                class="r4"
                :class="
                  show['deepstate.' + thisparent + '.' + k]
                    ? 'fa fa-minus'
                    : 'fa fa-plus'
                "
              ></i>
              <b class="update-text state_content_value">{{ k }}</b>
            </div>
          </span>
          <div v-if="newkey[k]">
            <input
              @blur="$set(newkey, k, false)"
              class="xs-input xs-font"
              @change="newkey[k].length > 0 && changekey(k, newkey[k])"
              type="text"
              v-model="newkey[k]"
            />
            <select
              @change="
                $set(
                  thisstatedata,
                  k,
                  newinput[thisparent + k + 'changetype']()
                )
              "
              v-model="newinput[thisparent + k + 'changetype']"
            >
              <option
                :value="item"
                v-for="item in [Boolean, String, Number, Object, Array]"
                :key="item.name"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
          <iinput
            :stick="stick"
            v-model="thisstatedata[k]"
            :name="'stateinput' + k"
          />
          <row j="between">
            <div
              v-if="typeof k !== 'number'"
              @click="newkey[k] ? $set(newkey, k, false) : $set(newkey, k, k)"
            >
              <i class="fa fa-edit r4"></i> Edit key
            </div>
            <rm :name="k" :obj="thisstatedata" />
          </row>
        </div>
        <state
          v-model="thisstatedata[k]"
          :parent="thisparent + '.' + k"
          v-if="
            show['deepstate.' + thisparent + '.' + k] &&
            ((typeof v == 'string' && validjson(v)) || typeof v == 'object') &&
            v !== null &&
            v !== undefined
          "
          :list="list"
          :editable="editable"
          :createable="createable"
          :tree="tree"
          :statedata="validjson(v) ? JSON.parse(v) : v"
          :nesting="+nesting + 1"
        />
        <fieldset v-if="add[thisparent + k]">
          <div v-if="Array.isArray(v)">add array entry</div>
          <div v-else>add object entry</div>
        </fieldset>

        <select
          v-model="add[thisparent + k + 'type']"
          @change="thisstatedata[k] = createtype(add[thisparent + k + 'type'])"
          v-if="typeof v == 'object' && v == null"
          name=""
          id=""
        >
          <option
            v-for="datatype in [
              'String',
              'Number',
              'Array',
              'Object',
              'Boolean',
            ]"
            :key="datatype"
            :value="datatype"
          >
            {{ datatype }}
          </option>
        </select>
      </div>
    </div>
    <div v-else>
      <label>
        <a
          @click="
            $store.commit('setState', {
              prop: 'select',
              prop2: select,
              val: { parent: thisparent, val: thisstatedata },
            });
            updatevalue(thisparent);
          "
          class="xs-font update-text flex align-center"
          v-if="
            select &&
            thisparent.split('.')[thisparent.split('.').length - 1] !== 'state'
          "
        >
          <b>
            <i class="fas fa-thumbtack"></i>
            {{ thisparent.split(".")[thisparent.split(".").length - 1] }}
          </b>
        </a>
        <select v-if="!list && !tree" v-model="breadcrumb">
          <option disabled selected>{{ breadcrumb }} properties</option>
          <option
            @change="
              typeof v == 'object' && Object.keys(v).length > 0
                ? $store.commit('show', { thisparent, key: k })
                : null
            "
            :value="k"
            v-for="(v, k) in thisstatedata"
            :key="thisparent + '.' + k"
          >
            {{ k }}
            {{
              typeof v == "object"
                ? Array.isArray(v)
                  ? `[ ${v.length} ]`
                  : `{ ${Object.keys(v).length} }`
                : ""
            }}
          </option>
        </select>
      </label>
      <div v-if="tree" class="flex column state_tree">
        <div
          class="flex column"
          :class="'state_' + thisparent + '_' + k"
          v-for="(v, k) in thisstatedata"
          :key="thisparent + '.' + k"
        >
          <div
            class="flex column"
            v-if="typeof v == 'object' && !(v instanceof Date)"
            @click.prevent="
              typeof v == 'object' && Object.keys(v).length > 0
                ? $store.commit('show', { thisparent, key: k })
                : null;
              breadcrumb = k;
            "
          >
            <span
              class="state_list_label p4"
              :class="
                typeof v == 'object' ? 'indicate fit xs-font t16 ' : ' r8 '
              "
              >{{ typeof k === "string" ? k.toUpperCase() : k }}</span
            >
            <state
              v-if="v !== null && v !== undefined"
              :statedata="v"
              tree="tree"
              :editable="editmode && 'true'"
              :editmode="editmode"
              :parent="thisparent + '.' + k"
              :nesting="+nesting + 1"
            />
          </div>
          <div v-else class="sm-font">
            <b>{{ k }}: </b>
            <!-- <itime :timestamp="v" v-if="typeof v === 'string' && !isNaN(Date.parse(v)) && new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}} === 'Jan 1, 2000 00:00'"></itime> -->
            <span class="state_content_value">{{ v }}</span>
          </div>
        </div>
      </div>

      <div v-else-if="list" class="flex column state_list sm-font">
        <div
          class="wrap flex sm-font"
          :class="
            'state_' +
            thisparent +
            '_' +
            k +
            (typeof v !== 'object' &&
            ((v && v.length && v.length < 140) ||
              typeof v === 'number' ||
              typeof v === 'boolean')
              ? ' align-center'
              : ' column ')
          "
          v-for="(v, k) in thisstatedata"
          :key="thisparent + '.' + k"
        >
          <span
            @click="
              $set(show, thisparent + '.' + k, !show[thisparent + '.' + k])
            "
            v-if="k && typeof k == 'string'"
            class="state_list_label p4"
            :class="typeof v == 'object' ? 'indicate fit t8 xs-font' : ' r8 '"
          >
            <span>{{ typeof k === "string" ? k.toUpperCase() : k }}</span>
            <span v-if="typeof v == 'object'">
              <i
                :class="
                  !show[thisparent + '.' + k]
                    ? 'l4 fa fa-caret-down'
                    : 'l4 fa fa-caret-up'
                "
              ></i>
            </span>
          </span>
          <b v-if="typeof v === 'string' && isNaN(+v)">
            <short v-if="!v.includes(' ') && v.length > 20" :str="v" />
            <icontent v-else class="state_content_value" :content="v" />
          </b>
          <code v-else-if="typeof v === 'boolean'">{{ v }}</code>
          <b
            class="state_content_value"
            v-else-if="v && typeof +v === 'number' && !isNaN(+v)"
            >{{ Number(v).toLocaleString("en-US") }}</b
          >
          <state
            v-else-if="
              typeof v === 'object' &&
              v !== null &&
              v !== undefined &&
              show[thisparent + '.' + k]
            "
            :parent="thisparent + '.' + k"
            :statedata="v"
            list="true"
            :editable="editable"
            :createable="createable"
            :editmode="editmode"
            :nesting="+nesting + 1"
          />
        </div>
      </div>

      <div
        v-if="
          !searchdata ||
          (searchdata &&
            thisstatedata[breadcrumb] &&
            JSON.stringify(thisstatedata[breadcrumb])
              .concat(breadcrumb)
              .indexOf(searchdata) >= 0)
        "
      >
        <span
          @click="
            thisstatedata[breadcrumb] !== null &&
            typeof thisstatedata[breadcrumb] == 'object' &&
            Object.keys(thisstatedata[breadcrumb]).length > 0
              ? $store.commit('show', { thisparent, key: breadcrumb })
              : null
          "
        >
        </span>
        <row
          v-if="
            thisstatedata[breadcrumb] !== null &&
            typeof thisstatedata[breadcrumb] !== 'object' && select && thisstatedata[breadcrumb]
          "
        >
          <a
            @click="
              $store.commit('setState', {
                prop: 'select',
                prop2: select,
                val: {
                  parent: thisparent + `.${breadcrumb}`,
                  val: thisstatedata[breadcrumb],
                },
              });
              updatevalue(thisstatedata[breadcrumb]);
            "
            class="sm-font indicate-text p4"
          >
            <i class="fas fa-thumbtack"></i>
          </a>
          <button type="button" class="update xs-font" @click="updatevalue(thisstatedata[breadcrumb])"><i class="fa fa-thumbtack r4"></i> Assign Value</button>
          <button type="button" class="update xs-font" @click="updatevalue('p__'+thisparent + `.${breadcrumb}`)"><i class="r4 fa fa-bullseye"></i> Assign Location</button>
        </row>
      </div>
      <div class="warn-text" v-else>No data matches search query</div>
      <state
        :editable="editable"
        :createable="createable"
        :tree="tree"
        :list="list"
        :key="breadcrumb + $store.state.counter"
        v-if="
          thisstatedata[breadcrumb] !== null &&
          thisstatedata[breadcrumb] !== undefined &&
          typeof thisstatedata[breadcrumb] == 'object' &&
          thisstatedata[breadcrumb] !== null &&
          (!searchdata ||
            JSON.stringify(thisstatedata[breadcrumb])
              .toLowerCase()
              .indexOf(searchdata.toLowerCase()) > -1)
        "
        :statedata="thisstatedata[breadcrumb]"
        :searchdata="searchdata"
        :parent="thisparent + '.' + breadcrumb"
        style="padding: 16px"
        :select="select"
        :nesting="+nesting + 1"
      />
      <code v-else>
        <span class="state_content_value">{{ thisstatedata[breadcrumb] }}</span>
      </code>
    </div>
  </div>
</template>
<style>
.state_component {
  line-break: anywhere;
}
</style>
<script>
// import itime from '../uxui/itime.vue';
export default {
  // components: { itime },
  name: "state",
  data() {
    return {
      input: this.value,
      breadcrumb: "",
      findparent: this.$parent,
      editmode: this.editable,
      add: {},
      model: {},
      newkey: {},
      show: {},
      newinput: {},
      thisstatedata: this.statedata,
      thisparent: this.parent || "this",
      jsonerror: false,
    };
  },
  props: {
    statedata: { type: [Object, Array, XMLHttpRequest] },
    parent: { type: String },
    name: { type: String },
    searchdata: { type: String },
    select: { type: String },
    tree: { type: String },
    list: { type: String },
    editable: { type: String },
    stick: { type: Boolean }, // disallows iinput choice
    nesting: { type: [String, Number], default: 0 },
    type: { type: String },
    vmodel: { type: String },
    createable: { type: String },
    value: {
      type: [String, Object, Number, Boolean, Array, Function],
    },
  },
  methods: {
    updatevalue: function (value) {
      this.$emit("input", value);
    },
    validjson(str) {
      try {
        if (+str + +str == +str * 2) return false;
        JSON.parse(str);
        this.$set(this, "jsonerror", false);
        return true;
      } catch (e) {
        this.$set(this, "jsonerror", true);
        return false;
      }
    },
    createitem(name, model) {
      this.$store.dispatch("create", {
        type: "fromdata",
        data: { name, model },
      });
    },
    changekey(oldkey, newkey) {
      this.$set(this.thisstatedata, newkey, this.thisstatedata[oldkey]);
      return this.$delete(this.thisstatedata, oldkey);
    },
    createtype(type) {
      let types = {
        Object: { "new key": null },
        Array: ["new value"],
        String: "",
        Number: 0,
        Boolean: true,
      };
      let newtype = types[type];
      return newtype;
    },
    is(x) {
      return x == null
        ? "null"
        : typeof x == "object"
        ? (Array.isArray(x) && "array") || "object"
        : typeof x == "string" && !isNaN(Number(x))
        ? "number"
        : typeof x;
    },
  },
  mounted() {
    this.$on("statechange-" + this.thisparent, (e) => {
      let parent = this.$parent;
      for (let x = 0; x < this.nesting; x++) {
        parent = parent.$parent;
      }

      let objpath = this.thisparent.split(".");

      let objpathcount = objpath.length;
      let updatepath = parent[objpath[0]];
      for (let x = 1; x < objpathcount; x++) {
        updatepath = updatepath[objpath[x]];
      }

      updatepath = e;
      parent[objpath[0]]["veryrandomwhowouldusethisasakey"] = "noone";
      this.$delete(parent[objpath[0]], "veryrandomwhowouldusethisasakey");
    });
  },
};
</script>